import React from 'react'
import { Button } from '@material-ui/core'

export default (props) => {
  const { style } = props
  return (
    <Button
      {...props}
      style={style ? { borderRadius: 35, ...style } : { borderRadius: 35 }}
    />
  )
}
